export default {
  proxyBidTypes: 'proxy_bid_types',
  autoRedLightOdometer: 'AUTO_RED_LIGHT_ODOMETER',
};
